import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type GlobalPairWithId = {
  idGlobalPair: number;
};

// Типы для WebSocket сообщений компонента globalPairs
type GlobalPairRootMessage = WebSocketMessageWithFields<'global-pair-root' | 'global-pair-calc' | 'global-pair-data' | 'global-pair-exchange' | 'global-pair-graph' | 'global-pair-indicator' | 'pair' | 'pair-graph' | 'pair-blockchains', {
  globalPair: {
    idGlobalPair: string;
    idGlobalCurrency: string;
    idCurrency: string;
    showOnMainPage: boolean;
    useInQuantfury: boolean;
    locked: boolean;
    lastCandleTimes: unknown;
    lastIndicatorTimes: unknown;
    timeStart: unknown;
  };
}>;
type GlobalPairRootNotFoundMessage = WebSocketMessageEmpty<'global-pair-root-not-found' | 'global-pair-calc-not-found' | 'global-pair-data-not-found'>;
type GlobalPairDataUpdateMessage = WebSocketMessageWithFields<'pair-update' | 'global-pair-data-update', {
  idGlobalPair: string;
  candlesLast?: unknown[];
  indicatorsLast?: unknown[];
}>;
type GlobalPairCalcUpdateMessage = WebSocketMessageWithFields<'calc-update', {
  candlesLast?: unknown[];
  indicatorsLast?: unknown[];
}>;
type GlobalPairListMessage = WebSocketMessageWithFields<'global-pair-list' | 'main' | 'pairs' | 'pairs-quantfury' | 'calc-info', {
  globalPairs: unknown[];
  candlesLast?: unknown[];
  indicatorsLast?: unknown[];
}>;
type GlobalPairAddMessage = WebSocketMessageWithFields<'global-pair-add' | 'global-pair-add-success', GlobalPairWithId & {
  idGlobalCurrency: number;
  idCurrency: number;
}>;
type GlobalPairRootUpdateMessage = WebSocketMessageWithFields<'global-pair-root-update' | 'global-pair-root-update-success', GlobalPairWithId & {
  showOnMainPage: boolean;
  useInQuantfury: boolean;
}>;
type GlobalPairDeleteMessage = WebSocketMessageWithFields<'global-pair-delete' | 'global-pair-delete-success', GlobalPairWithId>;
type GlobalPairLockMessage = WebSocketMessageWithFields<'global-pair-lock' | 'global-pair-lock-success', GlobalPairWithId>;
type GlobalPairUnlockMessage = WebSocketMessageWithFields<'global-pair-unlock' | 'global-pair-unlock-success', GlobalPairWithId>;

// Объединенный тип для всех сообщений
type GlobalPairsWebSocketMessage = 
  | GlobalPairRootMessage 
  | GlobalPairRootNotFoundMessage 
  | GlobalPairDataUpdateMessage 
  | GlobalPairCalcUpdateMessage 
  | GlobalPairListMessage 
  | GlobalPairAddMessage 
  | GlobalPairRootUpdateMessage 
  | GlobalPairDeleteMessage 
  | GlobalPairLockMessage 
  | GlobalPairUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataGlobalPairs',
},
  __name: 'globalPairs',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID глобальной пары
const handleWebSocketMessage = (data: GlobalPairsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'global-pair-root':
    case 'global-pair-calc':
    case 'global-pair-data':
    case 'global-pair-exchange':
    case 'global-pair-graph':
    case 'global-pair-indicator':
    case 'pair':
    case 'pair-graph':
    case 'pair-blockchains':
      store.dispatch('globalPair/wsSetGlobalPair', {
        idGlobalPair: parseInt(data.globalPair.idGlobalPair),
        idGlobalCurrency: parseInt(data.globalPair.idGlobalCurrency),
        idCurrency: parseInt(data.globalPair.idCurrency),
        showOnMainPage: data.globalPair.showOnMainPage,
        useInQuantfury: data.globalPair.useInQuantfury,
        locked: data.globalPair.locked,
      });
      break;
    case 'global-pair-root-not-found':
    case 'global-pair-calc-not-found':
    case 'global-pair-data-not-found':
      store.dispatch('globalPair/wsSetEmptyGlobalPair');
      break;

    case 'pair-update':
    case 'global-pair-data-update':
      // Обновление данных глобальной пары
      break;

    case 'calc-update':
      // Обновление расчетов глобальной пары
      break;

    case 'global-pair-list':
    case 'main':
    case 'pairs':
    case 'pairs-quantfury':
    case 'calc-info':
      store.dispatch('globalPairs/wsSetGlobalPairs', { globalPairs: data.globalPairs });
      break;

    case 'global-pair-add':
    case 'global-pair-add-success':
      store.dispatch('globalPairs/wsGlobalPairCreate', {
        idGlobalPair: data.idGlobalPair,
        idGlobalCurrency: data.idGlobalCurrency,
        idCurrency: data.idCurrency,
      });
      break;

    case 'global-pair-root-update':
    case 'global-pair-root-update-success':
      store.dispatch('globalPairs/wsGlobalPairUpdate', {
        idGlobalPair: data.idGlobalPair,
        showOnMainPage: data.showOnMainPage,
        useInQuantfury: data.useInQuantfury,
      });
      store.dispatch('globalPair/wsGlobalPairUpdate', {
        idGlobalPair: data.idGlobalPair,
        showOnMainPage: data.showOnMainPage,
        useInQuantfury: data.useInQuantfury,
      });
      break;

    case 'global-pair-delete':
    case 'global-pair-delete-success':
      store.dispatch('globalPairs/wsGlobalPairDelete', {
        idGlobalPair: data.idGlobalPair,
      });
      store.dispatch('globalPair/wsGlobalPairDelete', {
        idGlobalPair: data.idGlobalPair,
      });
      break;

    case 'global-pair-lock':
    case 'global-pair-lock-success':
      store.dispatch('globalPairs/wsGlobalPairLock', {
        idGlobalPair: data.idGlobalPair,
      });
      store.dispatch('globalPair/wsGlobalPairLock', {
        idGlobalPair: data.idGlobalPair,
      });
      break;

    case 'global-pair-unlock':
    case 'global-pair-unlock-success':
      store.dispatch('globalPairs/wsGlobalPairUnlock', {
        idGlobalPair: data.idGlobalPair,
      });
      store.dispatch('globalPair/wsGlobalPairUnlock', {
        idGlobalPair: data.idGlobalPair,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})